/**
 * Reduces credit_pricing rows (tool='staging') to the display prices for the
 * CreditsView "Was kostet was" table: newest row wins per (version_type,
 * event_type). Defaults mirror the historical hardcoded values.
 */
interface PricingRow {
  version_type: string;
  event_type: string;
  credit_cost: number;
  effective_from: string;
}

export function latestStagingPrices(rows: PricingRow[]): {
  stagedFirst: number;
  emptyFirst: number;
  refinement: number;
} {
  const latest: Record<string, PricingRow> = {};
  for (const r of rows) {
    const key = `${r.version_type}/${r.event_type}`;
    if (!latest[key] || r.effective_from > latest[key].effective_from) latest[key] = r;
  }
  const at = (vt: string, et: string, def: number) => {
    const row = latest[`${vt}/${et}`];
    return row ? Number(row.credit_cost) : def;
  };
  return {
    stagedFirst: at('Staged', 'first', 1),
    emptyFirst: at('Empty', 'first', 1),
    refinement: at('Staged', 'refinement', 0),
  };
}
